import { render, staticRenderFns } from "./TipoPage.vue?vue&type=template&id=07ada7d8"
import script from "./TipoPage.js?vue&type=script&lang=js&external"
export * from "./TipoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports